import { render, staticRenderFns } from "./archive.html?vue&type=template&id=3267a04d&scoped=true&"
import script from "./archive.js?vue&type=script&lang=js&"
export * from "./archive.js?vue&type=script&lang=js&"
import style0 from "./archive.scss?vue&type=style&index=0&id=3267a04d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3267a04d",
  null
  
)

export default component.exports